import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {RawDetailInfoInterface} from '../raw-detail-Info.interface';

@Component({
    selector: 'dmp-dyn-raw-detail-dialog',
    templateUrl: './dyn-raw-detail-dialog.component.html',
    styleUrls: ['./dyn-raw-detail-dialog.component.scss'],
    standalone: false
})
export class DynRawDetailDialogComponent implements OnInit {
    public configCmp: RawDetailInfoInterface;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit(): void {
      this.configCmp = this.config.data;
  }

}
